/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import WmsCollapse from "../../../components/WmsCollapse/WmsCollapse.jsx";
import * as CarrierService from "../../small-parcel-settings.services.jsx";
import * as GlobalService from "../../../global_services.js";
import "./new-provider-connection.scss";
import WmsModel from "../../../components/WmsModel/WmsModel.jsx";
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import DynamicCarrierFormComponent from "./dynamic-carrier-form.component";
import WmsCheckBox from "../../../components/WmsCheckBox/WmsCheckBox.jsx";

declare var window: any;

interface Props {
    selector: string;
    isOpenCarrierConnectionModel: boolean;
    sharedSelectedCarrierAccountData: any;
    sharedCarrierConnectionFlow: any;
    closeCarrierConnection: () => void;
    sharedFacilityOption: any;
    onResetSelectionAndGridRefresh: () => void;
    sharedShipEngineCarrier: any;
    sharedSelectedCustomer: any;
}

const stepOneDefaultObj = {
    selectedContentType: "",
    selectedFacilityIndex: "",
    selectedCustomerIndex: "",
    selectedCarrierIndex: "",
    selectedProviderIndex: "",
    IncludeShippingCost: false,
};

const DynamicProviderConnectionModel: React.FC<Props> = (props: Props): any => {
    const carrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();
    let selectedCustomerName = props.sharedSelectedCustomer.name;
    const getResponsiveDimensions = () => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        // Calculate responsive width (80% of window width, with min/max constraints)
        const responsiveWidth = Math.min(Math.max(windowWidth * 0.8, 800), 1200);

        // Calculate responsive height - ensure footer is visible by leaving space at bottom
        // WmsModel uses 200px total padding (100px top + 100px bottom)
        // Add 50px top and bottom margins when carrier list is shown
        const topBottomMargin = isCarrierAccList ? 100 : 0; // 50px top + 50px bottom
        const maxAvailableHeight = windowHeight - topBottomMargin;
        const responsiveHeight = Math.min(Math.max(windowHeight * 0.65, 877), maxAvailableHeight);

        return {
            width: responsiveWidth,
            height: responsiveHeight,
        };
    };

    const [modelDimensions, setModelDimensions] = useState(() => {
        return {
            width: 800,
            height: 877,
        };
    });
    const [selectedFacilityObj, setSelectedFacilityObj] = useState(null);
    const [selectedCustomerObj, setSelectedCustomerObj] = useState(null);
    const [connectionSchemaXgroupings, setConnectionSchemaXgroupings] = useState([]);
    const [connectionSchemaProperties, setConnectionSchemaProperties] = useState([]);
    const [connectionSchemaRequired, setConnectionSchemaRequired] = useState([]);
    const [isProviderConnection, setIsProviderConnection] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState("");
    const [selectedProviderObj, setSelectedProviderObj] = useState(null);
    const [currentCarrierImgUrl, setCurrentCarrierImgUrl] = useState("");
    const [currentStep, setCurrentStep] = useState(1);
    const [stepOneObject, setStepOneObject] = useState(stepOneDefaultObj);
    const [providerIndex, setProviderIndex] = useState("");
    const [providerOptions, setProviderOptions] = useState([]);
    const [carrierConnectionBtnLoader, setCarrierConnectionBtnLoader] = useState(false);
    const [carrierAccList, setCarrierAccList] = useState([]);
    const [isCarrierAccList, setIsCarrierAccList] = useState(false);
    const [connectionDisplay, setConnectionDisplay] = useState(null);
    const modalId = "dynamicCarrierConnection";
    const customerAccountText = "Customer Account";
    const warehouseAccountText = "Warehouse Account";
    const xGroupingText = "x-groupings";
    const rights = GlobalService.GetRights();
    const customerOptions = GlobalService.getCustomerList();
    const facilityOption = GlobalService.getFacilityList(false);
    const [isCalledParcelApi, setIsCalledParcelApi] = useState(false);
    const isEnableProvider =
        rights.hasOwnProperty("Shipping.SmallParcelEnabled") &&
        rights["Integrations.SmallParcelPartner"] === "ParcelApi";
    const carrierElementClass = isEnableProvider ? "new-connection-four-elements" : "new-connection-three-elements";

    useEffect(() => {
        if (carrierAccountSchema) {
            let providerOptions = [];
            for (const providerName in carrierAccountSchema) {
                const provider = carrierAccountSchema[`${providerName}`];
                if (
                    provider.settings &&
                    provider.settings.listPossibleConnectionAccounts &&
                    provider.settings.listPossibleConnectionAccounts.value &&
                    provider.connectionSchema
                ) {
                    providerOptions.push({
                        DisplayName: provider.name,
                        Code: providerName,
                        Settings: provider.settings,
                    });
                }
            }
            setProviderOptions(providerOptions);
        }

        // Add window resize listener to update modal dimensions dynamically
        const handleResize = () => {
            const dimensions = getResponsiveDimensions();
            setModelDimensions((prev) => ({
                ...prev,
                width: dimensions.width,
                height: dimensions.height,
            }));
            // Update carrier list height if it's currently displayed
            if (isCarrierAccList) {
                setTimeout(setCarrierListHeight, 50);
            }
        };

        window.addEventListener("resize", handleResize);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeEvent = (e: any) => {
        let name = e.target.name;
        let tmpStepOneObj = Object.assign({}, stepOneObject);

        if (e.target.type === "checkbox") {
            tmpStepOneObj[`${name}`] = !tmpStepOneObj[`${name}`];
        } else {
            tmpStepOneObj[`${name}`] = e.target.value;
        }

        if (name === "selectedContentType" && e.target.value === warehouseAccountText) {
            tmpStepOneObj.IncludeShippingCost = true;
        }

        if (name === "selectedContentType" && (!e.target.value || e.target.value === customerAccountText)) {
            tmpStepOneObj.IncludeShippingCost = false;
        }

        if (
            name === "selectedCustomerIndex" &&
            tmpStepOneObj.selectedContentType === customerAccountText &&
            e.target.value
        ) {
            let tmpCustomerObj = customerOptions[e.target.value];
            selectedCustomerName = tmpCustomerObj.name;
            setSelectedCustomerObj(tmpCustomerObj);
        }
        if (name === "selectedFacilityIndex" && e.target.value) {
            let tmpFacilityObj = facilityOption[e.target.value];
            setSelectedFacilityObj(tmpFacilityObj);
        }
        if (name === "selectedProviderIndex" && e.target.value) {
            let tmpProviderObj = providerOptions[e.target.value];
            tmpStepOneObj.selectedProviderIndex = tmpProviderObj.Code;
            setSelectedProvider(tmpProviderObj.DisplayName);
            setProviderIndex(e.target.value);
            setSelectedProviderObj(tmpProviderObj);
        }

        if (
            (name === "selectedContentType" &&
                (!e.target.value || tmpStepOneObj.selectedContentType !== customerAccountText)) ||
            (name === "selectedCustomerIndex" && !e.target.value)
        ) {
            selectedCustomerName = props.sharedSelectedCustomer.name;
        }

        setStepOneObject(tmpStepOneObj);
    };

    const handleCheckboxChangeEvent = (key: string) => {
        setStepOneObject((prev) => ({
            ...prev,
            [key]: !prev[`${key}`],
        }));
    };

    const movePreviousStep = () => {
        let prvStep = currentStep - 1;
        if (currentStep === 1 && isCarrierAccList) {
            setIsCarrierAccList(false);
        }
        setCurrentStep(prvStep);
        setIsProviderConnection(false);
    };

    const moveNextStep = async () => {
        kendo.ui.progress($("#" + modalId), true);
        let nxtStep = currentStep + 1;
        let tmpProviderConnection = isProviderConnection;
        let selectedProviderIndex = stepOneObject.selectedProviderIndex;

        if (currentStep === 1) {
            setCarrierConnectionBtnLoader(true);
            let tmpSelectedProviderIndex = selectedProviderIndex;
            await CarrierService.getProviderDetail(tmpSelectedProviderIndex)
                .then((response: any) => {
                    if (response.data) {
                        getCarrierAccountList(tmpSelectedProviderIndex, response.data.AccountNumber);
                    } else {
                        tmpProviderConnection = true;
                        setIsCalledParcelApi(true);
                        if (carrierAccountSchema) {
                            nxtStep = currentStep + 1;
                            for (const providerName in carrierAccountSchema) {
                                if (selectedProviderIndex === providerName) {
                                    if (
                                        carrierAccountSchema[`${selectedProviderIndex}`].connectionSchema[
                                            `${xGroupingText}`
                                        ]
                                    ) {
                                        setConnectionSchemaXgroupings(
                                            carrierAccountSchema[`${selectedProviderIndex}`].connectionSchema[
                                                `${xGroupingText}`
                                            ]
                                        );
                                    } else {
                                        setConnectionSchemaXgroupings([]);
                                    }
                                    // Set Properties
                                    setConnectionSchemaProperties(
                                        carrierAccountSchema[`${selectedProviderIndex}`].connectionSchema["properties"]
                                    );
                                    // If Required then set
                                    if (carrierAccountSchema[`${selectedProviderIndex}`].connectionSchema["required"]) {
                                        setConnectionSchemaRequired(
                                            carrierAccountSchema[`${selectedProviderIndex}`].connectionSchema[
                                                "required"
                                            ]
                                        );
                                    } else {
                                        setConnectionSchemaRequired([]);
                                    }
                                    kendo.ui.progress($("#" + modalId), false);
                                }
                            }
                        }
                        setConnectionDisplay(carrierAccountSchema[`${selectedProviderIndex}`].connectionDisplay);
                        kendo.ui.progress($("#" + modalId), false);
                    }
                })
                .finally(() => {
                    setCarrierConnectionBtnLoader(false);
                });
        }
        setIsProviderConnection(tmpProviderConnection);
        setCurrentCarrierImgUrl(carrierAccountSchema[`${selectedProviderIndex}`].logo);
        setCurrentStep(nxtStep);
    };

    const isDisabledNextButton = () => {
        const isStepOne = currentStep === 1;
        const selectedContentType = stepOneObject.selectedContentType;
        const isWarehouseInvalid = selectedContentType === warehouseAccountText && !stepOneObject.selectedFacilityIndex;
        const isCustomerInvalid = selectedContentType === customerAccountText && !stepOneObject.selectedCustomerIndex;
        const isCarrierOrProviderInvalid = isEnableProvider && !stepOneObject.selectedProviderIndex;

        return (
            isStepOne && (!selectedContentType || isWarehouseInvalid || isCustomerInvalid || isCarrierOrProviderInvalid)
        );
    };

    const setCarrierListHeight = () => {
        // Set CSS custom properties for responsive height calculations
        // Account for modal header, footer, padding, and 50px top/bottom margins
        const availableHeight = window.innerHeight - 450; // 350 + 100 (50px top + 50px bottom margins)
        const gridHeight = Math.max(Math.min(availableHeight, 600), 300); // Min 300px, Max 600px
        const contentHeight = gridHeight - 80; // Account for grid header

        document.documentElement.style.setProperty("--carrier-list-height", `${gridHeight}px`);
        document.documentElement.style.setProperty("--carrier-list-content-height", `${contentHeight}px`);
    };

    const getCarrierAccountList = (provider: string, accountNumber: string) => {
        let extraParam = "";
        if (stepOneObject.selectedContentType === warehouseAccountText) {
            extraParam = `&facilityid=${selectedFacilityObj.id}`;
        } else {
            extraParam = `&customerid=${selectedCustomerObj.id}`;
        }
        CarrierService.getCarrierAccountList(provider, accountNumber, extraParam)
            .then((response: any) => {
                setCarrierAccList(response.data.ResourceList);
                const dimensions = getResponsiveDimensions();
                setModelDimensions({
                    width: dimensions.width,
                    height: dimensions.height,
                });
                setIsCarrierAccList(true);
                // Set responsive height for carrier list after state update
                setTimeout(() => {
                    setCarrierListHeight();
                    // Force a small delay to ensure proper centering after all updates
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"));
                    }, 50);
                }, 100);
            })
            .finally(() => {
                kendo.ui.progress($("#" + modalId), false);
                setCarrierConnectionBtnLoader(false);
            });
    };

    const addDynamicCarrier = (dynamicCarrierObj: any, isFormResetLink: boolean) => {
        setCarrierConnectionBtnLoader(true);
        let tmpDynamicCarrierObj = {
            provider: "",
            carrier: "",
            customerId: "",
            facilityId: "",
            nickname: dynamicCarrierObj.nickname,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            data: dynamicCarrierObj,
            ShipEngineId: "",
        };

        let facilityObj = facilityOption[stepOneObject.selectedFacilityIndex];
        let customerObj = customerOptions[stepOneObject.selectedCustomerIndex];

        if (isEnableProvider) {
            tmpDynamicCarrierObj.provider = stepOneObject.selectedProviderIndex;
        }

        if (facilityObj && stepOneObject.selectedContentType === warehouseAccountText) {
            tmpDynamicCarrierObj.facilityId = facilityObj.id;
        } else {
            tmpDynamicCarrierObj.customerId = customerObj.id;
        }
        CarrierService.addDynamicCarrier(tmpDynamicCarrierObj, selectedProviderObj, isCalledParcelApi)
            .then((response: any) => {
                // Check for carrier Accounts
                if (response && (response.status === 200 || response.status === 204) && isCalledParcelApi) {
                    getCarrierAccountList(selectedProviderObj.Code, response.data.AccountNumber);
                    GlobalService.notificationNewDesign(
                        "success",
                        window.translate("Account_Connected"),
                        window.translate("New_provider_Connection_Success")
                    );
                } else if (response && (response.status === 200 || response.status === 204)) {
                    if (response && response.data.ShipEngineId) {
                        // Update Ship Engine Settings
                        tmpDynamicCarrierObj.ShipEngineId = response.data.ShipEngineId;
                        if (
                            tmpDynamicCarrierObj.carrier === "UPS" ||
                            (tmpDynamicCarrierObj.carrier === "FedEx" && tmpDynamicCarrierObj.provider === "shipEngine")
                        ) {
                            CarrierService.updateCarrier(tmpDynamicCarrierObj);
                        }
                    }
                    GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                    props.onResetSelectionAndGridRefresh();
                    setTimeout(() => {
                        props.closeCarrierConnection();
                    }, 10);
                } else {
                    GlobalService.notification("error", window.translate("Authorize_With_Failed"));
                    setCarrierConnectionBtnLoader(false);
                }
            })
            .catch((error: any) => {
                setCarrierConnectionBtnLoader(false);
                if (isCalledParcelApi) {
                    GlobalService.notificationNewDesign(
                        "error",
                        window.translate("Account_Connected_Failed"),
                        window.translate("Account_Connected_Failed_Content")
                    );
                }
            })
            .finally(() => {
                if (!isCalledParcelApi) {
                    setCarrierConnectionBtnLoader(false);
                }
            });
    };

    const addAccountListCarrier = (resourceList: any) => {
        setCarrierConnectionBtnLoader(true);
        let payload = {
            customerId: selectedCustomerObj ? selectedCustomerObj.id : null,
            facilityId: selectedFacilityObj ? selectedFacilityObj.id : null,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            ResourceList: resourceList,
        };
        CarrierService.createCarrierAccounts(payload)
            .then((response: any) => {
                GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                props.onResetSelectionAndGridRefresh();
                setTimeout(() => {
                    props.closeCarrierConnection();
                }, 10);
            })
            .finally(() => {
                setCarrierConnectionBtnLoader(false);
            });
    };

    const resetAccountCarrierList = () => {
        setIsCarrierAccList(false);
        setModelDimensions({
            width: 800,
            height: 750,
        });
        // Clean up CSS custom properties
        document.documentElement.style.removeProperty("--carrier-list-height");
        document.documentElement.style.removeProperty("--carrier-list-content-height");

        if (connectionSchemaProperties.length === 0 && currentStep > 1) {
            setCurrentStep(1);
        }
    };

    return (
        <WmsModel
            id={modalId}
            title={window.translate("Title_New_provider_Connection_Model")}
            width={modelDimensions.width}
            height={modelDimensions.height}
            maxHeight={window.innerHeight - 100} // Override default maxHeight calculation
            class={"new-provider-connection-wrapper" + (isCarrierAccList ? " carrier-account-list" : "")}
            onCloseFunc={props.closeCarrierConnection}
            isOpen={props.isOpenCarrierConnectionModel}
            customClass="wms-model-new-ui-wrapper"
            style={isCarrierAccList ? { marginTop: "50px", marginBottom: "50px" } : {}}
        >
            {/* First Step */}
            {currentStep === 1 && (
                <>
                    <div className="model-content-wrapper">
                        <div className={"wms-carrier-connection " + carrierElementClass}>
                            <WmsCollapse
                                id={"dynamicCarrierSelectConnection"}
                                headerLabel={window.translate("Label_Provider_Select")}
                                showCollapseText={false}
                                showCollapseIcon={false}
                            >
                                <WmsDropdown
                                    id="selectedContentType"
                                    name="selectedContentType"
                                    label={window.translate("Label_Connection_Type")}
                                    wmsSelector={props.selector + "contentType"}
                                    onChangeFunc={handleChangeEvent}
                                    value={stepOneObject.selectedContentType}
                                    options={[
                                        {
                                            Text: warehouseAccountText,
                                            Value: warehouseAccountText,
                                        },
                                        {
                                            Text: customerAccountText,
                                            Value: customerAccountText,
                                        },
                                    ]}
                                    valueField="Value"
                                    textField="Text"
                                    parentClassName="form_group"
                                    blankFirstOption={true}
                                    extraWrapperClass={"new-connection-first-element"}
                                />
                                {stepOneObject.selectedContentType === customerAccountText ? (
                                    <WmsDropdown
                                        id="selectedCustomerIndex"
                                        name="selectedCustomerIndex"
                                        label={window.translate("FindOrders_Lbl_Customer")}
                                        wmsSelector={props.selector + "customer"}
                                        onChangeFunc={handleChangeEvent}
                                        value={stepOneObject.selectedCustomerIndex}
                                        options={customerOptions}
                                        valueField="id"
                                        textField="name"
                                        parentClassName="form_group"
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-second-element"}
                                    />
                                ) : (
                                    <WmsDropdown
                                        id="selectedFacilityIndex"
                                        name="selectedFacilityIndex"
                                        label={window.translate("Label_Warehouse_Text")}
                                        wmsSelector={props.selector + "facility"}
                                        onChangeFunc={handleChangeEvent}
                                        value={stepOneObject.selectedFacilityIndex}
                                        options={facilityOption}
                                        valueField="id"
                                        textField="name"
                                        parentClassName="form_group"
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-second-element"}
                                    />
                                )}

                                {isEnableProvider && (
                                    <WmsDropdown
                                        id="selectedProviderIndex"
                                        name="selectedProviderIndex"
                                        label={window.translate("Label_Provider")}
                                        wmsSelector={props.selector + "service"}
                                        onChangeFunc={handleChangeEvent}
                                        value={providerIndex}
                                        options={providerOptions}
                                        valueField="Code"
                                        textField="DisplayName"
                                        parentClassName="form_group"
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-third-element"}
                                    />
                                )}
                                {stepOneObject.selectedContentType && (
                                    <div className="display-include-cost">
                                        <WmsCheckBox
                                            id={"IncludeShippingCost"}
                                            name={"IncludeShippingCost"}
                                            onChangeFunc={() => handleCheckboxChangeEvent("IncludeShippingCost")}
                                            label={window.translate("Label_Include_Shipping_Cost")}
                                            checked={stepOneObject.IncludeShippingCost}
                                            wmsSelector={props.selector + "IncludeShippingCost"}
                                            disabled={!stepOneObject.selectedContentType}
                                        />
                                    </div>
                                )}
                                {stepOneObject.selectedContentType === customerAccountText && (
                                    <div className="display-include-cost">
                                        <p>
                                            For this account, label charges will be recorded and added to your invoice
                                            for <b>{selectedCustomerName}</b>.
                                        </p>
                                    </div>
                                )}
                                {stepOneObject.selectedContentType === warehouseAccountText && (
                                    <div className="display-include-cost">
                                        <p>
                                            For this account, label charges will be recorded and added to your invoice
                                            for <b>all customers in this warehouse.</b>
                                        </p>
                                    </div>
                                )}
                                {stepOneObject.IncludeShippingCost &&
                                    stepOneObject.selectedContentType === customerAccountText && (
                                        <div className="display-include-cost">
                                            <div className="alert-text-wrapper">
                                                <i className="far fa-triangle-exclamation" aria-hidden="true"></i>
                                                <span> {window.translate("Label_Include_Shipping_Cost_Warning")} </span>
                                            </div>
                                        </div>
                                    )}
                            </WmsCollapse>
                        </div>
                    </div>
                    <div className="footer-btn-holder">
                        <WmsButton
                            label={window.translate("Label_Close")}
                            buttonType="orange"
                            wmsSelector={props.selector + "exitDynamicConnection"}
                            onClickFunc={props.closeCarrierConnection}
                            icon="fa-times-circle-o"
                        />
                        <WmsButton
                            label={window.translate("Label_Previous")}
                            wmsSelector={props.selector + "previous"}
                            onClickFunc={movePreviousStep}
                            icon="fa-caret-left"
                            disabled={currentStep === 1 && !isProviderConnection}
                        />
                        <WmsButton
                            label={window.translate("Label_Next")}
                            wmsSelector={props.selector + "next"}
                            onClickFunc={moveNextStep}
                            icon={"fa-caret-right"}
                            loading={carrierConnectionBtnLoader}
                            disabled={isDisabledNextButton()}
                        />
                    </div>
                </>
            )}

            {/* Second Step */}
            {currentStep === 2 && (
                <>
                    <DynamicCarrierFormComponent
                        selector={props.selector}
                        connectionTermsOfService={[]}
                        connectionSchemaXgroupings={connectionSchemaXgroupings}
                        connectionSchemaProperties={connectionSchemaProperties}
                        connectionSchemaRequired={connectionSchemaRequired}
                        closeCarrierConnection={props.closeCarrierConnection}
                        selectedCarrier={""}
                        selectedProvider={selectedProvider}
                        currentCarrierImgUrl={currentCarrierImgUrl}
                        movePreviousStep={movePreviousStep}
                        totalSteps={2}
                        currentLoginLabel={"Login"}
                        addDynamicCarrier={addDynamicCarrier}
                        addAccountListCarrier={addAccountListCarrier}
                        carrierConnectionBtnLoader={carrierConnectionBtnLoader}
                        authUrl={""}
                        isAuthUrl={false}
                        carrierAccList={carrierAccList}
                        isCarrierAccList={isCarrierAccList}
                        authFlowCurrentStep={0}
                        setIsCarrierAccList={resetAccountCarrierList}
                        isCarrierConnectionWorking={"None"}
                        startOverConnectionAuthorize={() => {}}
                        checkConnectionAuthorized={() => {}}
                        checkCarrierConnectionBtnLoader={false}
                        checkConnectionAuthorizedFinal={() => {}}
                        selectedFacilityObj={selectedFacilityObj}
                        selectedCustomerObj={selectedCustomerObj}
                        selectedCustomerName={selectedCustomerName}
                        connectionDisplay={connectionDisplay}
                    />
                </>
            )}
        </WmsModel>
    );
};

DynamicProviderConnectionModel.propTypes = {};

export default React.memo(DynamicProviderConnectionModel);
